export default __webpack_public_path__ + "static/media/person_2.b9b8a1e7.png";